<template>
  <div></div>
</template>

<script>
  /**
   * Componente que escucha eventos de pusher
   *
   * @author Manuel Ochoa
   */
  // import Pusher from 'pusher-js'
  // import {PUSHER_AUTH_URL} from '../utils/endpoints'
import { mapActions, mapGetters } from 'vuex'
import * as types from '../store/mutations-types'

  export default {
    name: 'pusher-listener',
    data() {
      return {
        realTimeData: [],
        isTimeoutRunning: false,
        pusherRefIn: {}
      }
    },
    computed: {
      ...mapGetters(['pusherRef']),
      ...mapGetters({
        profile: 'auth/getProfile'
      })
    },
    methods: {
      ...mapActions(['setPusherRef']),
      /**
       * Inicializa los canales que que va a escuchar la aplicación vía Sockets con Vue-Pusher
       * Y luego envía los datos
       *
       * Se utiliza Vue Pusher el cual solo es un wrapper que permite usar Pusher como un plugin
       *
       * @see {@link https://github.com/jaggy/vue-pusher | Ver más}
       */
      initialize() {
        // **************************************
        // JUSTIFICATION IN PROGRESS (presence)
        // **************************************
        this.presenceChannel = this.pusherRefIn.subscribe('presence-justification-in-progress')

        this.presenceChannel.bind('pusher:subscription_succeeded', (members) => {
          console.log('Success PCH2', members)
          this.$store.commit(types.SET_PUSHER_REF, this.pusherRefIn)
        })
        // console.log('PRESENCE CHANNEL 1', this.presenceChannel)

        this.presenceChannel.bind('pusher:subscription_error', (status) => {
          console.log('ERROR PCH2', status)
        })
        // console.log('PRESENCE CHANNEL 2', this.presenceChannel)

        this.presenceChannel.bind('pusher:member_added', function(member) {
          console.log('Member Added', member)
        })
        // console.log('PRESENCE CHANNEL 3', this.presenceChannel)

        // JUSTIFICATION IN PROGRESS
        this.presenceChannel.bind('client-justification-in-progress', (data, metadata) => {
          // console.log('client-justification-in-progress:', data)
          this.$store.dispatch('justificationInProgress', {data, metadata})
        })
        // -------------------------------------

        // **************************************
        // AVL CHANNEL
        // **************************************
        this.channel = this.pusherRefIn.subscribe('avl-channel')
        // console.log('CHANNEL', this.channel)

        this.channel.bind('pusher:subscription_succeeded', () => {
          console.log('Success PCH1')
        })
        // console.log('CHANNEL', this.channel)

        this.channel.bind('update-vehicle', (data) => {
          if (data) {
            this.$store.dispatch('updateVehiclePosition', data)
          }
        })

        this.channel.bind('new-alert', (data) => {
          // console.log(data)
          this.$store.dispatch('newAlert', data)
        })

        // Real Time Data from Operator
        // VEHICLES REAL TIME DATA
        // Las posiciones (realtime-avl) se toman del canal privado private-avl-channel, que exige
        // un idToken válido. Si la suscripción privada falla, se toman del canal público para que
        // el mapa no se quede sin datos. Los demás eventos siguen llegando por avl-channel.
        const onRealtimeAvl = (data) => {
          // console.log('realtime-avl')
          this.realTimeData = [...this.realTimeData, ...data]
          if (!this.isTimeoutRunning) {
            this.isTimeoutRunning = true
            setTimeout(() => {
              // console.log('READY TO SEND - TIME OUT', this.realTimeData)
              this.$store.dispatch('realtimeVehiclesData', this.realTimeData)
              this.realTimeData = []
              this.isTimeoutRunning = false
            }, 2500)
          }
        }
        this.realtimeChannel = this.pusherRefIn.subscribe('private-avl-channel')
        this.realtimeChannel.bind('pusher:subscription_succeeded', () => {
          console.log('Success private-avl-channel')
        })
        this.realtimeChannel.bind('pusher:subscription_error', (status) => {
          console.warn('private-avl-channel no autorizado, usando avl-channel para posiciones', status)
          this.channel.unbind('realtime-avl', onRealtimeAvl)
          this.channel.bind('realtime-avl', onRealtimeAvl)
        })
        this.realtimeChannel.bind('realtime-avl', onRealtimeAvl)

        // IN MISSION
        this.channel.bind('in-mission', data => {
          // console.log('IN MISSION PUSHER', data)
          this.$store.dispatch('updateVehicleInMissionPusher', data)
        })

        // New Operation (up, update, down) from Operator
        this.channel.bind('new-operation', data => {
          // console.log('NEW OPERATION: ', data.operation, data)
          this.$store.dispatch('newOperationAction', data)
        })

        // STATUS CHANGED
        this.channel.bind('status-changed', data => {
          // console.log('status-changed', data)
          this.$store.dispatch('updateVehicleStatusPusher', data)
        })

        // GEOFENCE IN ALARM JUSTIFIED
        this.channel.bind('generic-justification-missions_inside_alarms', data => {
          // console.log('generic-justification-missions_inside_alarms', data)
          this.$store.dispatch('updateJustificationGeofenceInEventAlarm', data)
        })

        // UNREPORTED ALARM JUSTIFIED
        this.channel.bind('generic-justification-unreported_event_alarms', data => {
          this.$store.dispatch('updateJustificationUnreportedEventAlarm', data)
        })

        // MOVEMENT ALARM JUSTIFIED
        this.channel.bind('generic-justification-movement_alarms', data => {
          this.$store.dispatch('updateJustificationMovementAlarm', data)
        })

        // MISSION ALARM JUSTIFIED
        this.channel.bind('alarms-justified', data => {
          // console.log('alarms-justified', data)
          this.$store.dispatch('updateJustificationMissionAlarm', data)
        })

        // SPEED ALARM JUSTIFIED
        this.channel.bind('generic-justification-alarms', data => {
          this.$store.dispatch('updateJustificationSpeedAlarm', data)
        })

        // PARKING ALARM JUSTIFIED
        this.channel.bind('generic-justification-parking_alarms', data => {
          this.$store.dispatch('updateJustificationParkingAlarm', data)
        })

        // DELETE MISSION
        this.channel.bind('mission-deleted', data => {
          // console.log('mission-deleted', data)
          this.$store.dispatch('deleteMissionPusher', data)
        })

        // TERMINATE MISSION
        this.channel.bind('mission-terminated', data => {
          // console.log('mission-terminated', data)
          this.$store.dispatch('terminateMissionPusher', data)
        })

        // MODIFY MISSION WHO
        this.channel.bind('mission-modified-who', data => {
          // console.log('mission-modified-who', data)
          this.$store.dispatch('modifiedWhoMissionPusher', data)
        })

        // MODIFY MISSION WHEN
        this.channel.bind('mission-modified-when', data => {
          // console.log('mission-modified-when', data)
          this.$store.dispatch('modifiedWhenMissionPusher', data)
        })

        // MODIFY MISSION WHERE
        this.channel.bind('mission-modified-where', data => {
          // console.log('mission-modified-where', data)
          this.$store.dispatch('modifiedWhereMissionPusher', data)
        })
        // -------------------------------------

        // **************************************
        // SOS ALERTS CHANNEL
        // **************************************
        this.sosChannel = this.pusherRefIn.subscribe('sos-alerts')

        this.sosChannel.bind('pusher:subscription_succeeded', () => {
          console.log('✅ Conectado al canal sos-alerts')
          console.log('Esperando eventos SOS...')
        })

        this.sosChannel.bind('pusher:subscription_error', (status) => {
          console.error('ERROR SOS Channel:', status)
        })

                        // SOS EVENT LISTENER
        this.sosChannel.bind('sos-event', (data) => {
          // El evento incluirá:
          // {
          //   notification_id: 123,  // ID único de la notificación
          //   sos_id: 456,
          //   deviceId: "device-123",
          //   licensePlate: "ABC123",
          //   location: { latitude: 4.7110, longitude: -74.0721 },
          //   timestamp: "2025-09-03T01:00:00Z",  // IMPORTANTE: Este timestamp se usa para mostrar la fecha del SOS
          //   message: "Alerta SOS recibida de ABC123",
          //   metadata: { eventType: 65, ... }
          // }
          console.log('🚨 SOS Event received:', data)

          // Verificar permisos antes de procesar la alerta
          const { shouldShowSOSAlert } = require('../utils/agencyPermissions')

          console.log('🔍 Checking SOS permissions for:', {
            deviceId: data.deviceId,
            licensePlate: data.licensePlate,
            userRoles: this.$store.getters['auth/role'],
            adminRole: this.$store.getters['auth/adminRole']
          })

          const isAllowed = shouldShowSOSAlert(data, this.$store.getters)

          if (isAllowed) {
            // Activar la alerta SOS en el store
            this.$store.dispatch('sosAlerts/activateSosAlert', data)

            // Enviar confirmación de recepción vía HTTP solo si tiene permisos
            this.sendSosReceptionConfirmation(data)
          } else {
            console.log('🚫 SOS Event filtered out - no confirmation sent:', data)
          }
        })
        // -------------------------------------

        // **************************************
        // ACTION IN MISSION IN PROGRESS (presence)
        // **************************************
        this.presenceChannelMissions = this.pusherRefIn.subscribe('presence-action-in-mission-in-progress')

        this.presenceChannelMissions.bind('pusher:subscription_succeeded', (members) => {
          console.log('Success PCH4', members)
          this.$store.commit(types.SET_PUSHER_REF, this.pusherRefIn)
        })

        this.presenceChannelMissions.bind('pusher:subscription_error', (status) => {
          console.log('ERROR PCH4', status)
        })

        this.presenceChannelMissions.bind('pusher:member_added', function(member) {
          console.log('Member Added', member)
        })

        this.presenceChannelMissions.bind('client-action-in-mission-in-progress', (data, metadata) => {
          this.$store.dispatch('actionInMissionInProgress', data)
        })
        // -------------------------------------

        // **************************************
        // CHANNEL REPORTS
        // **************************************
        const channelReportsName = `reports-${this.profile.email}`
        // console.log(channelReportsName)
        this.channelReports = this.pusherRefIn.subscribe(channelReportsName)
        // console.log('CHANNEL', this.channel)

        this.channelReports.bind('pusher:subscription_succeeded', () => {
          console.log('Success PCH3')
        })

        // NEW REPORT BY ROUTE TIME READY
        this.channelReports.bind('report-route', data => {
          // console.log('New Report By Route Time', data)
          let messageText = 'LISTO NUEVO REPORTE: Recorrido de un vehículo'
          if (data.error === 500) messageText = 'ERROR: Se ha presentado un error al tratar de generar el reporte. Por favor intentelo de nuevo.'
          this.$store.dispatch('notifyNewReportByRouteTime', {data, messageText})
        })
        // -------------------------------------
      },

      /**
       * Obtiene o genera un ID único del cliente
       */
      getClientId() {
        let clientId = localStorage.getItem('pusher_client_id')
        if (!clientId) {
          clientId = 'client_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9)
          localStorage.setItem('pusher_client_id', clientId)
        }
        return clientId
      },

      /**
       * Obtiene el ID del usuario actual
       */
      getUserId() {
        const userProfile = this.$store.getters['auth/getProfile']
        return (userProfile && userProfile.sub) || (userProfile && userProfile.id) || 'anonymous'
      },

      /**
       * Envía confirmación de recepción de evento SOS
       * Envía una petición HTTP al webhook
       * @param {Object} sosData - Datos del evento SOS recibido
       */
      async sendSosReceptionConfirmation(sosData) {
        try {
          const webhookUrl = 'https://c2q0025gnc.execute-api.us-east-1.amazonaws.com/prod/pusher-webhook'

          const confirmationData = {
            type: 'receipt',
            notification_id: sosData.notification_id,  // Usar el ID recibido en el evento
            user_id: this.getUserId(),                 // ID del usuario logueado
            sos_id: sosData.sos_id,                    // Opcional
            client_id: this.getClientId(),             // Opcional
            metadata: {                                // Opcional
              deviceInfo: navigator.userAgent,
              timestamp: new Date().toISOString(),
              location: window.location.pathname
            }
          }

          const response = await fetch(webhookUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(confirmationData)
          })

          if (response.ok) {
            const result = await response.json()
            console.log('Confirmación enviada:', result)
          } else {
            const errorText = await response.text()
            console.error('Error confirmando recepción:', errorText)
          }
        } catch (error) {
          console.error('Error enviando confirmación:', error)
        }
      }
    },
    async mounted() {
      this.pusherRefIn = await this.setPusherRef()
      // console.log('pusherRefIn', this.pusherRefIn)
      this.initialize()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PusherListener.vue